import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const KeygeekPurpleDawn = () => (
  <ArticleWrapper articleId="keygeek_purple_dawn">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>Keygeek Purple Dawn</h1>
        {/* Add your Keygeek Purple Dawn article content here */}
        <p>This is a placeholder article for the Keygeek Purple Dawn switch. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default KeygeekPurpleDawn;
